import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const SoftwareAttendanceService = {
    list: async (filters) => axios.post(API_URL + "/software-attendances/list", filters).then(({data}) => data).catch((err) => { throw err }),
    getLastAttendances: async (projectId) => axios.get(API_URL + "/software-attendances/get/last/" + projectId).then(({data}) => data).catch((err) => { throw  err}),
    getById: async (id) => axios.get(API_URL + `/software-attendances/${id}`).then(({data}) => data).catch(err => { throw err }),
    create: async (model) => axios.post(API_URL + "/software-attendances", model).then(({data}) => data).catch(err => { throw err }),
    edit: async (model, id) => axios.post(API_URL + "/software-attendances/" + id, model).then(({data}) => data).catch(err => { throw err }),
    editFavorite: async (model, id) => axios.post(API_URL + "/software-attendances/favorite/" + id, model).then(({data}) => data).catch(err => { throw err }),
    delete: async (id) => axios.delete(API_URL + "/software-attendances/" + id).then(({data}) => data).catch(err => { throw err }),
    dailyAttendance: async (model) => axios.post(API_URL + `/software-attendances/daily`, model).then(({data}) => data.data).catch(err => { throw err }),
}

export default SoftwareAttendanceService;